import * as React from 'react';
import strings from 'owa-strings/owa-calendar-strings';
import { format } from 'owa-strings';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';

let styles = require('./FindLocationInfo.scss');
let classNames = require('classnames');

export interface FindLocationInfoProps {
    infoType: FindLocationInfoType;
    queryString?: string;
}

/**
 * Enum definiton for the possible states of the LocationFindControl info tip (the footer)
 */
export enum FindLocationInfoType {
    Default = 0,
    Searching, // when loading results of a query string
    NoResults, // when no results are found for the query string
    Loading, // when loading suggestions with no query strings
}

export default class FindLocationInfo extends React.Component<FindLocationInfoProps, any> {
    render() {
        switch (this.props.infoType) {
            case FindLocationInfoType.Searching:
                return (
                    <div className={styles.container}>
                        <div className={styles.iconContainer}>
                            <Spinner className={styles.loadingSpinner} />
                        </div>
                        <div className={styles.textContainer}>
                            {format(strings.findLocationInfo_Searching, this.props.queryString)}
                        </div>
                    </div>
                );
            case FindLocationInfoType.Loading:
                return (
                    <div className={styles.container}>
                        <div className={styles.iconContainer}>
                            <Spinner className={styles.loadingSpinner} />
                        </div>
                        <div className={styles.textContainer}>
                            {strings.findLocationInfo_Loading}
                        </div>
                    </div>
                );
            case FindLocationInfoType.NoResults:
                return (
                    <div className={styles.container}>
                        <div className={classNames(styles.textContainer, styles.noResults)}>
                            {strings.findLocationInfo_NoMatchFound}
                        </div>
                    </div>
                );
            default:
                return null;
        }
    }
}
